(() => {
  function init(root) {
    root.querySelectorAll('[data-lr3-gallery]').forEach(gallery => {
      if (gallery.dataset.galleryReady) return;
      gallery.dataset.galleryReady = 'true';
      const track = gallery.querySelector('[data-gallery-track]');
      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      const previous = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      const count = gallery.querySelector('[data-gallery-count]');
      let index = 0;
      let frame = 0;
      const update = () => {
        frame = 0;
        if (!track.clientWidth) return;
        index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        count.textContent = `${index + 1} / ${slides.length}`;
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
      };
      const go = target => {
        index = Math.max(0, Math.min(slides.length - 1, target));
        track.scrollTo({left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => go(index - 1));
      next.addEventListener('click', () => go(index + 1));
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, {passive: true});
      new ResizeObserver(() => {
        if (track.clientWidth) track.scrollTo({left: index * track.clientWidth, behavior: 'instant'});
        update();
      }).observe(track);
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
